var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategoryListOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(0.0735387 .5em .5em)",
    rx: "0.013em",
    strokeWidth: "0.025em",
    stroke: "#5E5E5E",
    height: ".95em",
    width: ".95em",
    y: "0.025em",
    x: "0.025em",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: "0.013em",
    strokeWidth: "0.025em",
    height: "0.175em",
    width: "0.175em",
    y: "0.101em",
    x: "0.108em",
    stroke: "#5E5E5E",
    fill: "#1789ef"
  }), /*#__PURE__*/React.createElement("line", {
    y2: "0.349em",
    x2: "0.895em",
    y1: "0.349em",
    x1: "0.104em",
    strokeWidth: "0.038em",
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: "0.424em",
    x2: "0.894em",
    y1: "0.424em",
    x1: "0.101em",
    strokeWidth: "0.038em",
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: "0.013em",
    strokeWidth: "0.025em",
    height: "0.175em",
    width: "0.175em",
    y: "0.544em",
    x: "0.108em",
    stroke: "#5E5E5E",
    fill: "#1789ef"
  }), /*#__PURE__*/React.createElement("line", {
    y2: "0.793em",
    x2: "0.895em",
    y1: "0.793em",
    x1: "0.104em",
    strokeWidth: "0.038em",
    stroke: "#5E5E5E",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y2: "0.868em",
    x2: "0.894em",
    y1: "0.868em",
    x1: "0.101em",
    strokeWidth: "0.038em",
    stroke: "#5E5E5E",
    fill: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryListOrder);
export default __webpack_public_path__ + "static/media/categoryListOrder.0d0a9d04ef508216cc7b68edf6ebf253.svg";
export { ForwardRef as ReactComponent };